import React, {useEffect, useState} from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import photoGestureImg from '../../assets/img/photo_gesture.png';
import photoQrImg from '../../assets/img/photo_qr.png';

import gestureMale1Img from '../../assets/img/gesture/male/1.png';
import gestureMale2Img from '../../assets/img/gesture/male/2.png';
import gestureMale3Img from '../../assets/img/gesture/male/3.png';
import gestureMale4Img from '../../assets/img/gesture/male/4.png';
import gestureMale5Img from '../../assets/img/gesture/male/5.png';
import gestureFemale1Img from '../../assets/img/gesture/female/1.png';
import gestureFemale2Img from '../../assets/img/gesture/female/2.png';
import gestureFemale3Img from '../../assets/img/gesture/female/3.png';
import gestureFemale4Img from '../../assets/img/gesture/female/4.png';
import gestureFemale5Img from '../../assets/img/gesture/female/5.png';

import FileUpload from '../common/FileUpload';
import FormFooter from '../common/FormFooter';
import Spinner from '../common/Spinner';

import useScrollTop from '../../hooks/useScrollTop';
import {useDataProviderState, useDataProviderActions} from '../../providers/DataProvider';
import {postGestureFile} from '../../api/api';
import HighlightBox from "../common/HighlightBox.jsx";
import {TrackGoogleAnalyticsEvent} from "../../google-analytics/gaTracker.js";

export default function PhotoUploadStep() {
    const {loading, userData} = useDataProviderState();
    const {nextStep, setLoading} = useDataProviderActions();

    const [nextButtonDisabled, setNextButtonDisabled] = useState(true);

    useScrollTop();

    TrackGoogleAnalyticsEvent("PhotoUploadStep");

    async function handleNext() {
        nextStep();
    }

    let gestureImg = gestureMale1Img;

    useEffect(() => {
        if (userData.sexoId === 1) {
            switch (userData.gestoId) {
                case 1:
                    gestureImg = gestureMale1Img;
                    break;
                case 2:
                    gestureImg = gestureMale2Img;
                    break;
                case 3:
                    gestureImg = gestureMale3Img;
                    break;
                case 4:
                    gestureImg = gestureMale4Img;
                    break;
                case 5:
                    gestureImg = gestureMale5Img;
                    break;
            }
        } else {
            switch (userData.gestoId) {
                case 1:
                    gestureImg = gestureFemale1Img;
                    break;
                case 2:
                    gestureImg = gestureFemale2Img;
                    break;
                case 3:
                    gestureImg = gestureFemale3Img;
                    break;
                case 4:
                    gestureImg = gestureFemale4Img;
                    break;
                case 5:
                    gestureImg = gestureFemale5Img;
                    break;
            }
        }
    }, []);

    return (
        <Container component="section" maxWidth="sm">

            <Box sx={{pb: 2}}>
                <HighlightBox>
                    <Box sx={{display: 'flex'}}>
                        <Box sx={{py: 2}}>
                            <Box className="color-primary" sx={{pl: 3, pr: 3, pb: 1, fontSize: '1.3rem'}}>
                                <b>{userData.nombre},</b>
                            </Box>
                            <Box as="span" sx={{
                                display: 'inline-block',
                                px: 2,
                                color: 'white',
                                background: 'var(--color-primary)',
                                borderBottomRightRadius: '15px',
                                borderTopRightRadius: '15px',
                                fontSize: '1.2rem'
                            }}>
                                Vamos a garantizar la seguridad y confidencialidad de tus datos.
                            </Box>
                            <Box sx={{p: 1, pl: 2}}>
                                <b className="msg">Para ésto, te solicitamos que te tomes una selfie imitando este gesto.</b>
                            </Box>
                        </Box>
                    </Box>
                </HighlightBox>
            </Box>

            <Grid container spacing={{xs: 0, sm: 2, pb: 0}} alignItems="center" justifyContent="center">
                <Grid item sm={6} xs={12} sx={{pb: 0}} alignItems="center" justifyContent="center">
                    <Grid item sm={12} xs={12} sx={{pb: 0}}>
                        <Box sx={{display: 'flex', justifyContent: 'center', py: 2}}>
                            <Box sx={{alignItems: 'center'}}>
                                <img src={gestureImg} width="230" height="230"/>
                            </Box>
                        </Box>

                        <FileUpload
                            label="Subir la foto"
                            upload={postGestureFile}
                            onUploadSuccess={() => setNextButtonDisabled(false)}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <FormFooter
                hideBackButton
                onNext={handleNext}
                nextButtonDisabled={nextButtonDisabled}
            />

            <Spinner loading={loading}/>

        </Container>
    )

}
